// Temporary tokens are single-use, so every request that spends the shared
// token (Apple Pay merchant session, Apple Pay payment, Google Pay payment)
// runs through this one queue. A task must read the token when it starts and
// store the rotated token before it returns: the next task starts only then.
let tail = Promise.resolve();

export function runWithToken(task) {
  const run = tail.then(task);
  tail = run.catch(() => {});
  return run;
}

export const TOKEN_REQUEST_TIMEOUT_MS = 25000;
// `fetch` + body read bounded by one deadline. Aborting covers a stalled body
// read too, and a late response can no longer be delivered after the deadline.
export async function fetchBounded(
  url,
  init,
  readBody,
  timeoutMs = TOKEN_REQUEST_TIMEOUT_MS
) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetch(url, { ...init, signal: controller.signal });
    return { response, body: await readBody(response) };
  } finally {
    clearTimeout(timer);
  }
}
